import { Component, HostListener, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  private readonly router = inject(Router);

  scrolled = signal(false);
  mobileMenuOpen = signal(false);

  navLinks = [
    { label: 'Services', href: 'services' },
    { label: 'Projects', href: 'projects' },
    { label: 'About', href: 'about' },
    { label: 'Contact', href: 'contact' },
  ];

  @HostListener('window:scroll')
  onScroll() {
    this.scrolled.set(window.scrollY > 50);
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.update((v) => !v);
  }

  closeMobileMenu() {
    this.mobileMenuOpen.set(false);
  }

  goHome() {
    this.closeMobileMenu();
    void this.router.navigateByUrl('/');
  }

  goToSection(fragment: string) {
    this.closeMobileMenu();
    if (this.router.url.split('#')[0] === '/' || this.router.url === '') {
      const el = document.getElementById(fragment);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    void this.router.navigate(['/'], { fragment });
  }
}
